/** HashRouter cannot push state or duplicate hash paths — use a shared reload key instead. */
let routeReloadKey = 0;
const reloadListeners = new Set();

export function getRouteReloadKey() {
  return routeReloadKey;
}

export function subscribeRouteReload(listener) {
  reloadListeners.add(listener);
  return () => reloadListeners.delete(listener);
}

export function bumpRouteReload() {
  routeReloadKey = Date.now();
  reloadListeners.forEach((listener) => listener(routeReloadKey));
  return routeReloadKey;
}

export function routeContentKey(location) {
  return `${location.pathname}-${getRouteReloadKey()}`;
}

/** Navigate to path; always bumps reload key so content remounts even on the active item. */
export function navigateWithReload(history, path) {
  bumpRouteReload();
  if (history.location.pathname !== path) {
    history.push(path);
  }
}
